import { z } from 'zod';
import { ReachAPI } from '../../ReachApi';
import { forceTypingDeferred } from '../core';

type Cdn = {
    getAssetInfo: (uuid: string) => JQueryDeferred<unknown>;
};

export const assetInformationSchema = z.object({
    type: z.string(),
    name: z.string(),
    uuid: z.string(),
    arl: z.string(),
    redirect: z.string(),
});

export const assetInfoResponseSchema = z.object({
    assets: z.array(assetInformationSchema),
});

/**
 * GET Endpoint `/cdn/asset/info`
 * @throws {ReachApiRetrievalError}
 */
export const getCdnAssetInfo = function (
    uuid: string
): Promise<z.infer<typeof assetInfoResponseSchema>> {
    return forceTypingDeferred(assetInfoResponseSchema, (ReachAPI.cdn as Cdn).getAssetInfo(uuid));
};
